<template>
    <v-app>
        <v-container fluid class="mt-10">
            <v-row>
                <v-col>
                    <v-card>
                        <v-card-title>
                            <v-row>
                                <v-col cols="3">
                                    <v-menu v-model="menu1" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="90px">
                                        <template v-slot:activator="{ on }">
                                            <v-text-field v-model="datebegin" label="Date début" readonly v-on="on" dense outlined></v-text-field>
                                        </template>
                                        <v-date-picker dense v-model="datebegin" @input="menu1 = false"></v-date-picker>
                                    </v-menu>
                                </v-col>
                                <v-col cols="3">
                                    <v-menu v-model="menu2" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="90px">
                                        <template v-slot:activator="{ on }">
                                            <v-text-field v-model="dateend" label="Date fin" readonly v-on="on" dense outlined></v-text-field>
                                        </template>
                                        <v-date-picker v-model="dateend" @input="menu2 = false"></v-date-picker>
                                    </v-menu>
                                </v-col>
                            </v-row>

                        </v-card-title>
                        <v-card-text>
                            <column-chart :data="tableData" :colors="[['#d60001'],['#0b6e00']]"></column-chart>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </v-app>
</template>

<script>
    var date = new Date();
    import moment from 'moment'
    export default {
        name: "Stats",
        data() {
            return {
                menu1: false,
                menu2: false,
                datebegin: moment(new Date(date.getFullYear(), date.getMonth(), 1)).format('YYYY-MM-DD'),
                dateend: moment(new Date(date.getFullYear(), date.getMonth() + 1, 0)).format('YYYY-MM-DD'),
                tableData: []
            }
        },
        mounted() {
            this.initData();
        },
        watch : {
            datebegin : function(){
                this.initData()
            },
            dateend : function(){
                this.initData()
            }
        },
        methods: {
            initData: function(){
                let params = {}
                params.action = 'getDataStats'
                params.datebegin = this.datebegin
                params.dateend = this.dateend
                this.axios
                    .post(this.$store.state.rootUrl+'apiSalesNew.php',params,{timeout: 10000})
                    .then(data => {
                        if(data.data.error === true){
                            console.log('Error');
                            return false
                        }
                        this.tableData = data.data.data
                    })
                    .catch(error => {
                        console.log(error)
                    })
            }
        }
    }
</script>

<style scoped>

</style>
